import { Controller } from '@hotwired/stimulus'
import { DeclarativeWebPushManager } from '../notifications/declarative_web_push'

/**
 * Notification Cleanse Controller
 * Automatically synchronizes push notification tokens on page load
 * This runs silently on page load to ensure tokens stay synchronized with Apple's push service
 */
export default class extends Controller {
  connect () {
    // Run sync asynchronously without blocking page load
    this.syncTokens()
  }

  async syncTokens () {
    try {
      const ecosystemId = this.currentEcosystemId()

      // Only attempt sync if Declarative Web Push is supported
      const initCheck = DeclarativeWebPushManager.shouldInitialize()
      if (initCheck !== true) {
        console.log('[NotificationCleanse] Skipping sync:', initCheck)
        return
      }

      console.log('[NotificationCleanse] Starting token sync for ecosystem:', ecosystemId)
      // Call syncSubscription which handles verification, rotation, and orphan cleanup
      const result = await DeclarativeWebPushManager.syncSubscription(ecosystemId)

      if (result.changed) {
        console.log('🔄 [NotificationCleanse] Token rotated on homepage load')
      }
      if (result.orphanCleaned) {
        console.log('🧹 [NotificationCleanse] Orphaned subscription cleaned')
      }
      if (result.synced && !result.changed && !result.orphanCleaned) {
        console.log('✅ [NotificationCleanse] Token verified (no changes)')
      }

      console.log('[NotificationCleanse] Token sync completed:', result)
    } catch (err) {
      // Silent failure - we don't want to disrupt user experience
      console.error('[NotificationCleanse] Error during token sync:', err)
    }
  }

  currentEcosystemId () {
    return document.querySelector('meta[name="ecosystem_id"]')?.content || ''
  }
}
